var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle126(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "264.59267135100373 76.87974738049434 13.892342257099415 13.871045103080192",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M271.59,80.88c1.54.02,2.8,1.21,2.89,2.74.1,1.69-1.31,3.17-2.97,3.13-1.66-.04-3.03-1.57-2.91-3.23.11-1.49,1.43-2.66,2.99-2.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle126);
export default __webpack_public_path__ + "static/media/twinkle-1-26.9fdcd0450946e0d74b3bce7a9a913635.svg";
export { ForwardRef as ReactComponent };